import * as effects from 'redux-saga/effects';
import { api } from '@REST/api';
import { handleError } from '@bus/ui/saga/workers/handleError';
import { throwError } from '@bus/ui/saga/workers/throwError';

import { projectsActions } from '../../actions';
import {
  ChangeChatActionPayload,
  UpdateChatActionPayload,
} from '../../typedefs';
import { PayloadActionWithPromiseMeta } from '@core/FinalForm/typedefs';
import {
  FormErrors,
  getServerFormErrors,
  ServerFormErrors,
} from '@core/FinalForm/getServerErrors';
import { call } from 'redux-saga/effects';
import { profileActions } from '@bus/profile/actions';

export function* updateChat({
  payload,
  meta: { resolve, reject },
}: PayloadActionWithPromiseMeta<UpdateChatActionPayload>) {
  try {
    // yield effects.put(projectsActions.startFetching());
    const body: string = yield effects.call(JSON.stringify, payload);
    const response: Response = yield effects.apply(api, api.put, [
      { endpoint: `chats/${payload.id}`, body },
    ]);
    if (!response.ok) {
      const errors: ServerFormErrors = yield call([response, 'json']);
      const formErrors: FormErrors = yield call(getServerFormErrors, errors);
      reject(formErrors);
      yield throwError(response);
    }

    const data: ChangeChatActionPayload = yield effects.call([
      response,
      'json',
    ]);

    yield effects.put(projectsActions.changeChat(data));
    yield effects.put(profileActions.changeCurrentDataset(data));
    resolve();
  } catch (e) {
    yield handleError(e);
  } finally {
    // yield effects.put(projectsActions.stopFetching());
  }
}
